import { defineMessages } from 'react-intl';

export default defineMessages({
    stepCoverables: {
        id: 'quoteandbind.SpaAndWelProduct.wizard.step.Coverables',
        defaultMessage: 'Coverables',
    },
    questions: {
        id: 'quoteandbind.SpaAndWelProduct.wizard.step.Questions',
        defaultMessage: 'Questions',
    },
    stepCoverages: {
        id: 'quoteandbind.SpaAndWelProduct.wizard.step.Coverages',
        defaultMessage: 'Coverages',
    },
    exposures: {
        id: 'quoteandbind.SpaAndWelProduct.wizard.step.Exposures',
        defaultMessage: 'Exposures',
    },
    // add string ids and default values for localization here
});
